import { Row, Col, Typography } from 'antd';
import PropTypes from 'prop-types';
import { LRStyle } from './LRStyleSet';

const { Text, Paragraph } = Typography;

export function LRViewAddress({ addressType, partyName, partyAddress, partyPincode }) {
	return (
		<>
			<Text style={LRStyle.titleTextStyle}>{addressType}:</Text>
			<Row>
				<Col>
					<Text strong>{partyName}</Text>
				</Col>
			</Row>
			<Row>
				<Col span={16}>
					<Paragraph>{partyAddress}</Paragraph>
				</Col>
			</Row>
			<Row>
				<Col span={16}>
					<Text>Pincode: {partyPincode}</Text>
				</Col>
			</Row>
		</>
	);
}

LRViewAddress.propTypes = {
	addressType: PropTypes.string,
	partyName: PropTypes.string,
	partyAddress: PropTypes.string,
	partyPincode: PropTypes.number,
};
